import { isNumber } from '@agilepoint/utils-common';
import { Meridiem } from './time-picker-props';

const toDoubleDigitString = (value: string | number) => {
    const valueAsString = isNumber(value) ? value.toString() : value;
    return (valueAsString.length < 2 ? `0${valueAsString}` : valueAsString);
};

function getMeridiem(hour: string, meridiem?: Meridiem): Meridiem {
    if (!meridiem) {
        return Number(hour) < 12 ? Meridiem.AM : Meridiem.PM;
    }
    const meridiemUpperCase = meridiem.toUpperCase();
    return meridiemUpperCase === Meridiem.PM ? Meridiem.PM : Meridiem.AM;
}

export type ParsedTime = [string, string, string, Meridiem];

export function parseTime(time: string, timeSeperator: string): ParsedTime {
    let valueContainer: any[] = [];
    if (!time) { return ['', '', '', Meridiem.AM]; }
    const timeParts = time.split(' ');
    valueContainer = time.split(' ')[0].split(timeSeperator).map(toDoubleDigitString);
    if (valueContainer.length === 2) {
        valueContainer.push('00');
    }
    valueContainer.push(getMeridiem(valueContainer[0], timeParts[1] as Meridiem));
    return valueContainer as ParsedTime;
}

interface ITime {
    hour: string;
    minute: string;
    second: string;
    meridiem: Meridiem;
}

interface ITimeFormatOptions {
    showSecond?: boolean;
    is12Hour?: boolean;
    timeSeparator: string;
}

export const convertToValidHour = (hour: string, is12Hour?: boolean, meridiem: Meridiem = Meridiem.AM) => {
    const hourNumber = Number(hour) || (is12Hour ? 12 : 0);
    if (is12Hour) {
        return toDoubleDigitString(hourNumber === 12 ? hourNumber : hourNumber % 12);
    }

    if (meridiem === Meridiem.AM) {
        return toDoubleDigitString(hourNumber === 12 ? 0 : hourNumber);
    }

    return toDoubleDigitString(hourNumber + (hourNumber > 11 ? 0 : 12));
};

export function getTimeAsString(time: ITime, options: ITimeFormatOptions): string {

    const { hour, meridiem, minute, second } = time;
    const { is12Hour, showSecond, timeSeparator } = options;
    const timeString = `${convertToValidHour(hour, is12Hour, meridiem)}${timeSeparator}${toDoubleDigitString(minute || '00')}`;
    return `${timeString}${showSecond ? timeSeparator + (toDoubleDigitString(second || '00')) : ''}${is12Hour ? ' ' + (meridiem || Meridiem.AM) : ''}`;
}
